import { langCheck } from "Pub/js/utils";
import ItemSelect from './itemSelect';
import platform from "Pub/js/platform";
const { getLangCode, getBusinessInfo } = platform;
const { NCCheckbox  } = platform.base;
const TABLE_ID = "referFilterTable";

let langIndex = -1;

export default (props) => {
    const { json } = props;
    //获取区域其他字段
    const getOtherCards = () => {
        if (langIndex === -1) {
            let languageMeta = getBusinessInfo().languageMetas;
            langIndex = languageMeta.find(e => e.languageCode === getLangCode()).index;
            if (langIndex == '1') {
                langIndex = '0';
            }
        }

        const data = props.cards.map((item) => {
            if (item.code !== props.selectCard.code) {
                return { 
                    display: `${item['label' + langIndex]} ${item.code}`,
                    value: item.code
                };
            }
        });
        return data.filter((item) => item != undefined);
    };
    return {
        code: "20521030",
        pageid: "20521030",
        appCode: "",
        referFilterTable: {
            items: [
                {
                    attrcode: "value",
                    itemtype: "customer",
                    width: "280px",
                    visible: true,
                    label: langCheck("ZoneSetting-000338", "pages", json), /* 国际化处理： 依赖字段*/
                    required: true,
                    render: (text, record, index) => {
                        const values = record.values || {};
                        
                        const handleSelectChange = (val) => {
                            props.editTable.setValByKeyAndIndex(TABLE_ID, index, "value", {
                                value: val,
                            });
                        };
                            return (
                                <ItemSelect
                                    value={values.value.value}
                                    optionData={getOtherCards()}
                                    onChange={handleSelectChange}
                                />
                            );
                    },
                },
                {
                    attrcode: "key",
                    itemtype: "input",
                    width: "280px",
                    visible: true,
                    label: langCheck("ZoneSetting-000337", "pages", json), /* 国际化处理： 关联字段*/
                    required: true,
                },
                {
                    attrcode: "nofilter",
                    itemtype: "customer",
                    width: "120px",
                    visible: true,
                    label: langCheck("ZoneSetting-000350", "pages", json), /* 国际化处理：非过滤字段*/
                    required: false,
                    render:(text, record, index)=>{
                        const values = record.values || {};
                        let val = (values.nofilter && values.nofilter.value) ? values.nofilter.value :false;
                        const handleChange = (value) =>{
                            props.editTable.setValByKeyAndIndex(TABLE_ID, index, "nofilter", { value });
                        }
                        return <NCCheckbox checked={val}  onChange={handleChange} />
                    }
                },
            ],
            moduletype: "table",
            pagination: false,
            code: "referFilterTable",
        },
    };
};


